import { render, staticRenderFns } from "./ContentSubmissionView.vue?vue&type=template&id=18c2f547&"
import script from "./ContentSubmissionView.vue?vue&type=script&lang=js&"
export * from "./ContentSubmissionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports